import Account from "./components/Account";
import Dashboard from "./components/Dashboard";
import BarcodePrint from "./components/Barcode";
import CameraPermissionRequest from "./components/Camera";
import UsersPage from "./components/Users";
import SettingsPage from "./components/Settings";
import Vehicles from "./components/Vehicles";
import VehicleDetails from "./components/VehicleDetails";
import NewDvi from "./components/DviEditor.tsx";
import InspectionItems from "./components/InspectionItems.js";
import Inspections from "./components/Dvis.js";
import DviViewer from "./components/DviViewer.tsx";
import DviEditor from "./components/DviEditor.tsx";
import PrintQrs from "./components/PrintQrs.js";
import QrBatchPrint from "./components/PrintQrs.js";
import DealersLanding from "./components/LandingPage.js";
import CreateDealerForm from "./components/Onboarding.js";
import DealersAdmin from "./components/DealersAdmin.js";
import DealerInfo from "./components/DealerInfo.js";
import Activate from "./components/Activate.tsx";
import BillingComplete from "./components/BillingComplete.tsx";
import BillingPage from "./components/BillingPage.tsx";
import Scan from "./components/Scan.js";
import SmsAlertsPage from "./components/SmsAlerts.js";
import SmsTermsPage from "./components/SmsTerms.js";


const AppRoutes = [
  {
    index: true,
    path: '/',
    element: <DealersLanding />
  },
  {
    index: true,
    path: '/dashboard',
    element: <Dashboard />
  },
  {
    path: '/vehicles',
    element: <Vehicles />
  },
  {
    path: '/vehicles/:id',
    element: <VehicleDetails />
    
  },
  {
    path: '/dvis',
    element: <Inspections />
  },
  {
    path: '/dvi/new',
    element: <DviEditor />
  },

  {
    path: '/dvi/view/:id',
    element: <DviViewer />
  },
  {
    path: '/dvi/scan/:id',
    element: <Scan />
  },
  {
    path: '/dvi/:id',
    element: <DviEditor />
  },
  {
    path: '/print-qrs',
    element: <QrBatchPrint />
  },

  /*   {
      path: '/inventory/underThreshold',
      element: <Inventory onlyUnderThreshold={true} />
    },
    {
      path: '/inventory/pending',
      element: <Inventory onlyPending={true} />
    },
    {
      path: '/inventory/newWithBarcode/:barcode',
      element: <Inventory />
    }, */



  {
    path: '/account',
    element: <Account />
  },
  {
    path: '/barcode',
    element: <BarcodePrint />
  },
  {
    path: '/barcode/:barcode',
    element: <BarcodePrint />
  },
  {
    path: '/camera',
    element: <CameraPermissionRequest />
  },
  {
    path: '/users',
    element: <UsersPage />
  },
  {
    path: '/settings',
    element: <SettingsPage />
  },
  {
    path: '/sms-alerts',
    element: <SmsAlertsPage />
  },
  {
    path: '/sms-terms',
    element: <SmsTermsPage />
  },
  {
    path: '/dealer-info',
    element: <DealerInfo />
  },
  {
    path: '/inspection-items',
    element: <InspectionItems />
  },
  {
    path: '/get-started',
    element: <DealersLanding />
  },
  {
    path: '/admin',
    element: <DealersAdmin  />
  },
  {
    path: '/activate',
    element: <Activate  />
  },
  {
    path: '/billing/complete',
    element: <BillingComplete  />
  },
  {
    path: '/billing/success',
    element: <BillingComplete  />
  },
{
    path: '/billing/',
    element: <BillingPage  />
  },  

];

export default AppRoutes;
